import * as React from 'react';
import { Input } from '../../components/antd';
import { injectIntl, InjectedIntlProps } from 'react-intl';
const Search = Input.Search;

interface SearchInputProps {
  onSearch: (value: any) => any;
}

const LargeSearchInput: React.StatelessComponent<
  SearchInputProps & InjectedIntlProps
> = ({ intl, ...rest }) => (
  <Search
    {...rest}
    placeholder={intl.formatMessage({
      id: 'T1763.Subscription.searchbar.SearchBox',
    })}
    size="large"
  />
);

export const SearchInput = injectIntl(LargeSearchInput);



// WEBPACK FOOTER //
// ./app/components/antd/SearchInput.tsx